import { cva } from 'class-variance-authority';

// Общие стили для контейнера
export const container = cva(['flex', 'items-center', 'justify-center', 'p-6', 'w-full'], {
  variants: {
    theme: {
      light: 'bg-main_white',
      dark: 'bg-general_background_MIII_400_dark',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для кнопки "Назад"
export const backButton = cva(
  ['flex', 'items-center', 'gap-2', 'mb-4', 'transition-colors', 'font-inter'],
  {
    variants: {
      theme: {
        light: 'text-main_black/70 hover:text-main_black',
        dark: 'text-general_text_MII_secondary_i hover:text-general_text_MII_default',
      },
    },
    defaultVariants: {
      theme: 'light',
    },
  },
);

// Стили для основной карточки
export const card = cva(['rounded-3xl', 'overflow-hidden'], {
  variants: {
    theme: {
      light: 'bg-main_white border border-border-static',
      dark: 'bg-general_background_MIII_500_dark',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для заголовка карточки
export const cardHeader = cva(['p-4'], {
  variants: {
    theme: {
      light: 'bg-main_dark_blue',
      dark: 'bg-general_MI_500_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для заголовка h1
export const title = cva(['font-raleway', 'font-normal', 'text-[32px]', 'leading-[38px]', 'mb-2'], {
  variants: {
    theme: {
      light: 'text-main_white',
      dark: 'text-general_text_MII_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для подзаголовка
export const subtitle = cva(['font-inter', 'font-light', 'text-[20px]', 'leading-[24px]'], {
  variants: {
    theme: {
      light: 'text-main_white',
      dark: 'text-main_white',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для label
export const label = cva(['block', 'text-static-text', 'font-semibold', 'mb-2', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_dark_blue',
      dark: 'text-general_text_MII_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для кнопки выбора метода оплаты
export const paymentMethodButton = cva(
  [
    'w-full',
    'flex',
    'items-center',
    'justify-between',
    'border-2',
    'p-3',
    'transition-colors',
    'rounded-md',
  ],
  {
    variants: {
      theme: {
        light: 'bg-main_white border-border-static hover:border-main_blue',
        dark: 'bg-general_background_MIII_500_dark border-general_text_MII_secondary_i/30 hover:border-general_MI_500_default',
      },
    },
    defaultVariants: {
      theme: 'light',
    },
  },
);

// Стили для текста метода оплаты
export const paymentMethodText = cva(['font-medium', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_black',
      dark: 'text-general_text_MII_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для подзаголовка метода оплаты
export const paymentMethodSubtitle = cva(['text-static-text', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_black/70',
      dark: 'text-general_text_MII_secondary_i',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для иконки ChevronDown
export const chevronIcon = cva(['transition-transform'], {
  variants: {
    theme: {
      light: 'text-main_black/70',
      dark: 'text-general_text_MII_secondary_i',
    },
    isOpen: {
      true: 'rotate-180',
      false: '',
    },
  },
  defaultVariants: {
    theme: 'light',
    isOpen: false,
  },
});

// Стили для выпадающего меню
export const dropdown = cva(['z-10', 'w-full', 'border-2', 'rounded-md', 'shadow-lg'], {
  variants: {
    theme: {
      light: 'bg-main_white border-border-static',
      dark: 'bg-general_background_MIII_500_dark border-general_text_MII_secondary_i/30',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для элемента выпадающего меню
export const dropdownItem = cva(
  ['w-full', 'text-left', 'p-4', 'transition-colors', 'first:rounded-t-md', 'last:rounded-b-md'],
  {
    variants: {
      theme: {
        light: '',
        dark: '',
      },
      isSelected: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      {
        theme: 'light',
        isSelected: true,
        class: 'bg-main_blue/10',
      },
      {
        theme: 'light',
        isSelected: false,
        class: 'hover:bg-general_background_MIII_500',
      },
      {
        theme: 'dark',
        isSelected: true,
        class: 'bg-general_MI_500_default/10',
      },
      {
        theme: 'dark',
        isSelected: false,
        class: 'hover:bg-general_background_MIII_600_dark',
      },
    ],
    defaultVariants: {
      theme: 'light',
      isSelected: false,
    },
  },
);

// Стили для блока доверия
export const trustSignals = cva(['p-3', 'space-y-1.5'], {
  variants: {
    theme: {
      light: 'bg-general_background_MIII_500 rounded-static-nested',
      dark: 'bg-general_background_MIII_600_dark rounded-md',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для элемента доверия
export const trustSignalItem = cva(['flex', 'items-center', 'gap-2', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_black',
      dark: 'text-general_text_MII_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для иконки доверия
export const trustIcon = cva([''], {
  variants: {
    theme: {
      light: 'text-main_green',
      dark: 'text-main_green',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для CTA кнопки
export const ctaButton = cva(
  [
    'w-full',
    'font-raleway',
    'text-static-button',
    'h-button-static',
    'py-button-static-y',
    'px-button-static-x',
    'transition-all',
    'transform',
    'hover:scale-[1.02]',
    'text-main_white',
    'rounded-static-root',
    'disabled:opacity-50',
    'disabled:cursor-not-allowed',
  ],
  {
    variants: {
      theme: {
        light: 'bg-main_blue hover:bg-main_blue/90',
        dark: 'bg-general_MI_500_default hover:bg-general_MI_600_hover',
      },
    },
    defaultVariants: {
      theme: 'light',
    },
  },
);

// Стили для текста под кнопкой
export const ctaSubtext = cva(['text-center', 'text-sm', 'pt-6', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_black/70',
      dark: 'text-general_text_MII_secondary_i',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для блока сводки заказа
export const orderSummary = cva(['p-5', 'sticky', 'top-8', 'rounded-2xl'], {
  variants: {
    theme: {
      light: 'bg-general_background_MIII_500',
      dark: 'bg-general_background_MIII_600_dark',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для заголовка плана
export const planTitle = cva(
  ['font-raleway', 'font-bold', 'text-[24px]', 'leading-[24px]', 'mb-2'],
  {
    variants: {
      theme: {
        light: 'text-main_black',
        dark: 'text-general_text_MII_default',
      },
    },
    defaultVariants: {
      theme: 'light',
    },
  },
);

// Стили для периода биллинга
export const billingPeriodLabel = cva(
  ['font-raleway', 'font-normal', 'text-[16px]', 'leading-[20px]'],
  {
    variants: {
      theme: {
        light: 'text-main_black/50',
        dark: 'text-general_text_MII_secondary_i',
      },
    },
    defaultVariants: {
      theme: 'light',
    },
  },
);

// Стили для описания токенов
export const tokensDescription = cva(
  [
    'inline-flex',
    'items-center',
    'gap-1',
    'px-[12px]',
    'py-[4px]',
    'rounded-full',
    'mb-4',
    'font-inter',
    'font-medium',
  ],
  {
    variants: {
      theme: {
        light: 'text-main_black bg-main_white',
        dark: 'text-main_white bg-general_background_MIII_400_dark',
      },
    },
    defaultVariants: {
      theme: 'light',
    },
  },
);

// Стили для кнопки изменения плана
export const changePlanButton = cva(
  ['hover:opacity-80', 'font-inter', 'font-normal', 'text-[16px]', 'leading-[20px]'],
  {
    variants: {
      theme: {
        light: 'text-main_blue',
        dark: 'text-general_MI_500_default',
      },
    },
    defaultVariants: {
      theme: 'light',
    },
  },
);

// Стили для иконки фичи
export const featureIcon = cva(['mt-0.5', 'flex-shrink-0'], {
  variants: {
    theme: {
      light: 'text-main_green',
      dark: 'text-main_green',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для текста фичи
export const featureText = cva(['text-static-text', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_black',
      dark: 'text-general_text_MII_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для разделителя
export const divider = cva(['border-t', 'pt-3', 'space-y-1.5'], {
  variants: {
    theme: {
      light: 'border-border-static',
      dark: 'border-general_text_MII_secondary_i/30',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для border-t разделителя (только граница)
export const dividerBorder = cva(['border-t'], {
  variants: {
    theme: {
      light: 'border-border-static',
      dark: 'border-general_text_MII_secondary_i/30',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для текста в сводке
export const summaryText = cva(['font-inter', 'text-static-text'], {
  variants: {
    theme: {
      light: 'text-main_black/70',
      dark: 'text-general_text_MII_secondary_i',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для итоговой суммы
export const totalText = cva(['font-bold', 'text-lg', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_black',
      dark: 'text-general_text_MII_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для итоговой суммы (большая)
export const totalAmount = cva(['font-bold', 'text-2xl', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_black',
      dark: 'text-general_text_MII_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для текста биллинга
export const billingText = cva(['text-sm', 'pt-1', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_black/70',
      dark: 'text-general_text_MII_secondary_i',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для бейджа экономии
export const savingsBadge = cva(['mt-3', 'rounded-lg', 'p-2.5'], {
  variants: {
    theme: {
      light: 'bg-main_green/10 border-main_green/30',
      dark: 'bg-general_MI_500_default/10 border-general_MI_500_default/30',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});

// Стили для текста бейджа экономии
export const savingsText = cva(['text-static-text', 'font-medium', 'text-center', 'font-inter'], {
  variants: {
    theme: {
      light: 'text-main_green',
      dark: 'text-general_MI_500_default',
    },
  },
  defaultVariants: {
    theme: 'light',
  },
});
